"use client";

import { useMediaQuery, Dialog, DialogTitle, Typography, Button, Box } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const CommonModal: React.FC<{
  open: boolean;
  onClose: () => void;
  modalTitle: string;
  children: React.ReactNode;
}> = ({ open, onClose, modalTitle, children }) => {
  const lessThanMD = useMediaQuery("(max-width: 900px)");
  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={open}
        onClose={onClose}
        fullScreen={lessThanMD}
        sx={{
          ".MuiPaper-root": {
            backdropFilter: "blur(5px)",
            borderRadius: { xs: "0px", md: "14px" },
          },
          ".MuiPaper-root.MuiDialog-paper": {
            maxWidth: "1000px",
          },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#EDF1FF",
            padding: { xs: "10px 1rem", sm: "14px 1rem" },
            position: "sticky",
            top: "0px",
            zIndex: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "1.5rem", md: "1.5rem" },
              fontWeight: 600,
              fontFamily: "'blauerNue', 'blauerNue Fallback'",
              color: "#060273",
              position: "sticky",
              top: "0px",
            }}
          >
            {modalTitle}
          </Typography>
          <Button
            disableElevation
            sx={{
              minWidth: "unset",
              p: "2px 6px",
              minHeight: "unset",
              borderRadius: "8px",
              border: "1px solid #06027380",
              bgcolor: "#fff",
              color: "#060273",
              display: "grid",
              placeItems: "center",
              "&:hover": {
                bgcolor: "#fff",
              },
            }}
            onClick={onClose}
            variant="contained"
            aria-label="Close"
          >
            <CloseRoundedIcon sx={{ width: "1.4rem", height: "1.4rem" }} />
          </Button>
        </DialogTitle>

        <Box sx={{ width: "100%", overflowX: "hidden" }}>
          <Box sx={{ padding: "1rem" }}>{children}</Box>
        </Box>
      </Dialog>
    </>
  );
};

export default CommonModal;
